import React, {useContext, useEffect, useMemo} from "react";
import {Box, Typography} from "@mui/material";
import MapView from "./map"
import PropTypes from "prop-types";
import _ from "lodash";
import {AppDataContext} from "../../../../../App";
import dayjs from "dayjs";

const styles = {
    root: {
        display: 'flex',
        position: 'relative',
        width: '100%',
        height: '100%',
        gap: "8px",
    },
    detail: {
        overflowY: "auto",
        minWidth: "400px",
    },
    row: {
        display: 'flex',
        flexDirection: 'row',
        gap: '8px',
        borderBottom: "0.3px solid #ccc",
        marginBottom: "3px",
    },
    name: {
        width: "100px",
        color: "#333",
    },
    valueBox: {
        display: 'flex',
        flexDirection: 'row',
    },
    value: {
        fontWeight: "bold",
    },
    valueUnit: {

    },
    emptyValue: {
        color: "#999",
    },
    photo: {
        width: "120px",
    }
}

const TreeInfoDetailView = ({data, columnDefs, height}) => {

    const { state } = useContext(AppDataContext)

    useEffect(() => {
        console.log("[InfoDetail]", "data", data)
    }, [data])

    const content = useMemo(() => data.content, [data])

    const getValue = (value, def) => {
        console.log(value, def)
        let val = value
        let unit = def.unit

        switch(def.data_type) {
            case "float":
                val = parseFloat(val).toLocaleString()
                break
            case "int":
                val = parseInt(val).toLocaleString()
                break
            case "teiboku":
                val = val.join(",")
                break
            case "photos":
                return (
                    <Box style={styles.photosBox}>
                        {val.map(v => {
                            return (
                                <Box style={styles.photoBox}>
                                    {def.field !== "management_plate_photos" && (<img style={styles.photo} alt="photo" src={`${state.env.CLIENT_PHOTO_ENDPOINT_V2}/tree_photo/thumb/${v}`} />)}
                                    {def.field === "management_plate_photos" && (<img style={styles.photo} alt="photo" src={`${state.env.CLIENT_PHOTO_ENDPOINT_V2}/tree_plate/org/${v}`} />)}
                                </Box>
                            )
                        })}
                    </Box>
                )
            case "datetime":
                val = dayjs(val).format("YYYY-MM-DD HH:mm")
                break
            default:
                break
        }

        return (
            <Box style={styles.valueBox}>
                <Box style={styles.value}>{val}</Box>
                {unit && <Box style={styles.valueUnit}>{unit}</Box>}
            </Box>
        )
    }

    return (
        <Box style={{...styles.root, height}}>
            <Box style={styles.detail}>
                {content && columnDefs
                    .filter(v => !v.hide && v.field)
                    .filter(v => v.web?.visible || v.visible)
                    .map(def => {
                    return (
                        <Box style={styles.row} key={def.field}>
                            <Box style={styles.name}>{def.name}</Box>
                            {!_.isNil(content[def.field]) && getValue(content[def.field], def)}
                            {_.isNil(content[def.field]) && (<Box style={styles.emptyValue}>--</Box>)}
                        </Box>
                    )
                })}
            </Box>
            <MapView data={content} />
        </Box>
    )
}

TreeInfoDetailView.propTypes = {
    height: PropTypes.string,
    data: PropTypes.object,
    columnDefs: PropTypes.array,
}

export default TreeInfoDetailView
